import React, { useEffect } from "react";
import { Card, Rate, Row, Col } from "antd";
import {
  DoubleRightOutlined,
  DoubleLeftOutlined,
} from "@ant-design/icons";
import Slider from "react-slick";
import styled from "styled-components";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import realhomeimage from "../image/house.png";
import { useMediaQuery } from "@mui/material";
import { motion } from "framer-motion";
import AOS from "aos";
import "aos/dist/aos.css";

// Styled Components
const StyledContainer = styled.div`
  width: 90%;
  margin: 0 auto;
  text-align: center;
  position: relative;

  .slick-prev,
  .slick-next {
    font-size: 24px;
    color: #00a76f;
    z-index: 10;
  }

  .slick-prev {
    left: 10px;
  }

  .slick-next {
    right: 10px;
  }

  .slick-prev::before,
  .slick-next::before {
    font-size: 30px;
    color: #00a76f;
  }

  .subscribe-section {
    margin-top: 60px;
    text-align: center;

    h2 {
      font-size: 2rem;
      font-weight: bold;
    }

    p {
      color: #666;
      max-width: 500px;
      margin: 0 auto 20px;
    }

    .input-container {
      display: flex;
      justify-content: center;
      gap: 8px;
      margin-top: 10px;
      width: 100%;
      max-width: 500px;
      margin-left: auto;
      margin-right: auto;
    }

    @media (max-width: 768px) {
      .input-container {
        flex-direction: column;
        align-items: center;
      }
    }
  }
`;

const StyledCard = styled(Card)`
  background-color: rgb(255 255 255 / 94%) !important;
  backdrop-filter: blur(1px);
  border: 1px solid rgba(255, 255, 255, 0.2);
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);
  height: 300px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 20px;
  border-radius: 12px;
  overflow: hidden;
`;

const testimonials = [
  {
    name: "Rohit Patil",
    review:
      "Nexus Wealth Services helped us set up our hotel chain with top-quality furnishings at wholesale rates — a truly professional experience.",
    rating: 4.5,
  },
  {
    name: "Tushar Zamble ",
    review:
      "As an exporter, I rely on Nexus for both sourcing and documentation support. They are fast, reliable, and incredibly resourceful.",
    rating: 5,
  },
  {
    name: "Manoj Rane",
    review:
      "We were sourcing luxury linens and decor items for our resort expansion, and Nexus provided everything on time and within budget. Their attention to detail was commendable.",
    rating: 5,
  },
  {
    name: "Abhi Rathod",
    review:
      "We needed bulk fabric with very specific quality requirements, and Nexus delivered beyond expectations. Their textile division knows their craft!",
    rating: 4.5,
  },
];

const settings = {
  dots: true,
  infinite: true,
  speed: 500,
  slidesToShow: 3,
  autoplay: true,
  autoplaySpeed: 2000,
  slidesToScroll: 1,
  nextArrow: <DoubleRightOutlined />,
  prevArrow: <DoubleLeftOutlined />,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 2,
      },
    },
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 1,
      },
    },
  ],
};

const Section6 = () => {
  const isMobile = useMediaQuery("(max-width: 768px)");

  useEffect(() => {
    AOS.init({ duration: 2000 });
  }, []);

  return (
    <StyledContainer>
      <img
        src={realhomeimage}
        alt="decoration"
        style={{
          position: "absolute",
          left: isMobile ? "0px" : "-6px",
          top: "0px",
          width: isMobile ? "100%" : "17%",
          borderRadius: "300px",
        }}
      />
      <Row gutter={[16, 16]}>
        <Col xs={24} sm={3} />
        <Col xs={24} sm={18}>
          <motion.div
            whileHover={{ scale: 1.03 }}
            whileTap={{ scale: 1.0 }}
            className="motion-div"
            data-aos="fade-up"
          >
            <h1 style={{ backgroundColor: "", padding: "10px", borderRadius: "8px",textShadow: "3px 2px 8px #ffffff" }}>
            {/* dadada82 */}
              Testimonials
            </h1>

            <Slider {...settings}>
              {testimonials.map((testimonial, index) => (
                <StyledCard key={index}>
                  <div>
                    <h3 style={{ fontWeight: "bold", marginBottom: "10px", color: "#333" }}>
                      {testimonial.name || "Client"}
                    </h3>
                    <p style={{ fontSize: "14px", color: "#555" }}>{testimonial.review}</p>
                  </div>
                  <Rate disabled defaultValue={testimonial.rating} />
                </StyledCard>
              ))}
            </Slider>
          </motion.div>
        </Col>
        <Col xs={24} sm={3} />
      </Row>
      <br />
    </StyledContainer>
  );
};

export default Section6;
